import { Observable } from "../Observable.js";
class EmptyError extends Error {
  constructor(message = "No elements in single") {
    super(message);
    this.name = "EmptyError";
  }
}
class SequenceError extends Error {
  constructor(message) {
    super(message);
    this.name = "SequenceError";
  }
}
function single(predicate) {
  return (source) => {
    return new Observable((subscriber) => {
      let index = 0;
      let match;
      let hasFound = false;
      const sourceSubscription = source.subscribe({
        next: (value) => {
          try {
            if (predicate(value, index++)) {
              if (hasFound) {
                subscriber.error(new SequenceError("Sequence contains more than one element"));
                sourceSubscription.unsubscribe();
              } else {
                match = value;
                hasFound = true;
              }
            }
          } catch (err) {
            subscriber.error(err);
          }
        },
        error: (err) => {
          subscriber.error(err);
        },
        complete: () => {
          if (hasFound) {
            subscriber.next(match);
            subscriber.complete();
          } else {
            subscriber.error(new EmptyError());
          }
        }
      });
      return () => {
        sourceSubscription.unsubscribe();
      };
    });
  };
}
export {
  EmptyError,
  SequenceError,
  single
};
//# sourceMappingURL=single.js.map
